import { useState, useEffect } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";

export default function AgGridPaginatedTable({
  columns,
  perPage = 10,
  refreshCounter,
  getTableRows,
  onCellClicked = () => {},
}) {
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const rowHeight = 40;

  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          gridApi.showLoadingOverlay();
          const { rows, total, error } = await getTableRows(
            perPage,
            params.endRow - perPage
          );
          gridApi.hideOverlay();
          if (error) {
            params.successCallback([], 0);
          } else {
            params.successCallback(rows, parseInt(total));
          }
        },
      };
      gridApi.setDatasource(dataSource);
    }
  }, [gridApi, refreshCounter]);

  return (
    <div aria-live="polite" aria-busy={false} className="ag-theme-material">
      <AgGridReact
        columnDefs={columns}
        pagination={true}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onGridReady={onGridReady}
        domLayout="autoHeight"
        defaultColDef={{
          resizable: true,
          flex: 1,
        }}
        onCellClicked={onCellClicked}
        rowHeight={rowHeight}
        tooltipMouseTrack={true}
      />
    </div>
  );
}
